import { motion } from "framer-motion";
import { PARTNERS } from "@/data";

export default function PartnerBadges() {
  return (
    <div className="mt-6" data-testid="partner-badges">
      <p className="text-center font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-black/40">
        Official partner of
      </p>
      <div className="mt-4 flex flex-wrap items-center justify-center gap-x-7 gap-y-4">
        {PARTNERS.map((p, i) => (
          <motion.a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`partner-${p.name.split(" ")[0].toLowerCase()}`}
            title={p.name}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.7 + i * 0.1 }}
            whileHover={{ y: -3 }}
            className="block grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-[filter,opacity,transform] duration-300"
          >
            <img src={p.logo} alt={p.name} className="h-11 md:h-12 w-auto object-contain" />
          </motion.a>
        ))}
      </div>
    </div>
  );
}
